"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Exit = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Exit"));

// Generated by script, don't edit it please.
var Exit = (0, _createSvgIcon["default"])({
  as: _Exit["default"],
  ariaLabel: 'exit',
  category: 'action',
  displayName: 'Exit'
});
var _default = Exit;
exports["default"] = _default;
module.exports = exports.default;